<template>
  <div class="quote-box">
    <div class="isTxt" v-if="isTxt">
      {{ name || '-' }}
    </div>
    <template v-else>
      <el-select
        v-model="innerValue"
        remote
        class="custom-select"
        popper-class="quote-tableSubList-el-select-popover"
        reserve-keyword
        remote-show-suffix
        :placeholder="renderConfig.placeholder"
        :remote-method="remoteMethod"
        :loading="loading"
        style="width: 100%"
        filterable
        @change="changeValue"
        :suffix-icon="Search"
      >
        <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value">
          <div class="content">
            <div>{{ item.label }}</div>
            <div class="tags" v-if="item.subShowFieldsArr && item.subShowFieldsArr.length">
              <template v-for="(item2, index2) in item.subShowFieldsArr" :key="index2">
                <div class="item" :title="item2">{{ item2 }}</div>
                <span v-if="item.subShowFieldsArr.length !== index2 + 1" class="line">|</span>
              </template>
            </div>
          </div>
        </el-option>
      </el-select>
      <div class="showDialogOverlay" @click="handleShow" v-if="isShowDialog" />
    </template>
  </div>
  <RxkDialog width="700px" title="选择数据" v-model="showDialog" @sure="sure">
    <div class="dialog-box" v-if="showDialog">
      <div class="title-search">
        <div class="title">{{ data.name }}:</div>
        <RxkInput style="flex: 1" v-model="searchTxt" />
        <RxkButton type="primary" style="margin-left: 8px" @click="handleSearch">查询</RxkButton>
        <RxkButton @click="handleReset">重置</RxkButton>
      </div>
      <div class="table-box">
        <RxkVTable @register="registerTable" />
      </div>
    </div>
  </RxkDialog>
</template>
<script lang="tsx" setup>
import { Search } from '@element-plus/icons-vue'
import { computed, nextTick, onMounted, PropType, ref, unref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkDialog } from '@/components/common/RxkDialog'
import { getQuoteValue, tableDialogTitleColumnList } from '@/apis/objectManage'
import { useCustomerPageStore } from '@/stores/modules/customerPage'
import { fieldTypeConfig, fieldTypeEnum } from '@/enums/preObjectManage'
import { isArray, isEmpty, isNullOrUndefOrEmpty, isString } from '@/utils/is'
import { uniqueFunc } from '@/utils/util'
import {
  getPageComponentData,
  getPageComponentDataEchoAcquire,
  getTagForEcho
} from '@/apis/customerManage'
import {
  dealLabelValueConfig,
  dealQuoteValueConfig
} from '@/components/custom/form/components/utils'
import globalEnv from '@/configs/index'
import { RxkVTable } from '@/components/common/RxkVTable'
import { useTable } from '@/components/common/RxkVTable/src/hooks/useTable'
import { RxkInput } from '@/components/common/RxkInput'
import { ColumnType } from '@/types/table'
import {
  dealTableValueConfig,
  getTableColumnWidthByCode,
  isField,
  isSubList
} from '@/utils/preObjectManage/utils'
const seCustomerPage = useCustomerPageStore()

const props = defineProps({
  ...basicProps,
  quoteMappingConfig: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  index: {
    type: Number,
    default: 0
  },
  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})
const name = ref('')
const loading = ref(false)
const showDialog = ref(false)
const allListValue = ref<Recordable[]>([])

const emit = defineEmits(['update:modelValue', 'refreshDataList', 'refreshSubListRowDataId'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})

const searchTxt = ref('')
const columnsDialog = ref<Recordable[]>([])
async function handleSearch() {
  const query = searchTxt.value
  if (query && query !== ' ') {
    // 只有findField找得到字段，并且该字段有值才可以请求
    let conditionFlag = true
    const conditionInfo = props.data?.columnQuoteInfo?.conditionInfo
      ? JSON.parse(JSON.stringify(props.data.columnQuoteInfo.conditionInfo))
      : null
    // 这儿需要处理一下rightValue的问题，因为当前引用字段配的条件中可能有普通字段，在请求数据的时候，要把一个或多个普通字段的值带入
    // 当前条件的rightValue值中
    if (conditionInfo && conditionInfo.conditionList) {
      // 长度最长是2，最多2个条件，conditionList
      conditionFlag = conditionInfo?.conditionList.every((condis: Recordable) => {
        // 还要判断外部条件是and，还是or ， exteriorCondition
        // 还要判断内部条件是and，还是or , interiorCondition
        let flag = false // 当前这个外部条件是否为true的标识
        // 内部条件是否为true，还要取决于内部条件的AND还是OR
        if (condis.interiorCondition && condis.interiorCondition === 'AND') {
          flag = condis.conditions.every(condi => {
            const field = findField(condi.rightColumnSerial)
            if (!isEmpty(field)) {
              return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
            } else {
              return true
            }
          })
        } else {
          flag = condis.conditions.some(condi => {
            const field = findField(condi.rightColumnSerial)
            if (!isEmpty(field)) {
              return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
            } else {
              return true
            }
          })
        }
        return flag
      })
    }
    if (conditionFlag) {
      const { code } = props.data
      let queryVal = ''
      // 这里处理值要注意
      if (props.data.dataMark === 1) {
        // 要根据query去匹配columnDataList中的label，然后找到值
        // 模糊匹配
        // const curItem = props.data.columnDataList.find(item => item.label.)
        const strategyFn = dealQuoteValueConfig[code]
        if (strategyFn) {
          queryVal = strategyFn(props.data.columnDataList, query)
        }
      } else if (props.data.dataMark === 2) {
        // 已经查询过一次了
        if (props.data.renderConfig.dataList && props.data.renderConfig.dataList.length) {
          const strategyFn = dealQuoteValueConfig[code]
          if (strategyFn) {
            queryVal = strategyFn(props.data.renderConfig.dataList, query)
          }
        } else {
          // 调用接口之后再去匹配，然后找到对应的值，传递给后端
          //
          const postData = {
            tableCode: props.data?.columnQuoteInfo?.sourceTableCode || props.data.tableCode,
            columnId: props.data.id,
            columnUseScene: props.data.columnUseScene
          }
          const res = await getPageComponentData(postData)
          emit('refreshDataList', res)
          const strategyFn = dealQuoteValueConfig[code]
          if (strategyFn) {
            queryVal = strategyFn(res, query)
          }
        }
      } else {
        queryVal = query
      }
      if (queryVal) {
        loading.value = true
        // group相同的引用字段和映射字段的集合
        const sameGroup = getGroupField(props.data.columnQuoteInfo?.group)
        const quoteColumnList = sameGroup.map(field => {
          return {
            columnSerial: field.columnSerial,
            quoteColumnSerial: field.columnQuoteInfo.quoteColumnSerial,
            unionQueryColumnSerials: field.columnQuoteInfo.unionQueryColumnSerials || '',
            unionDialogColumnSerials: field.columnQuoteInfo.unionDialogColumnSerials || '',
            queryValue: props.data.fieldSerial === field.fieldSerial ? queryVal.split(',') : [], // 只有输入的当前字段才有值
            quoteModuleGroup: field.columnQuoteInfo.quoteModuleGroup || ''
          }
        })
        const conditionInfo = props.data?.columnQuoteInfo?.conditionInfo
          ? JSON.parse(JSON.stringify(props.data.columnQuoteInfo.conditionInfo))
          : null
        // 这儿需要处理一下rightValue的问题，因为当前引用字段配的条件中可能有普通字段，在请求数据的时候，要把一个或多个普通字段的值带入
        // 当前条件的rightValue值中
        if (conditionInfo && conditionInfo.conditionList) {
          conditionInfo?.conditionList.forEach((condis: Recordable) => {
            condis.conditions.forEach((condi: Recordable) => {
              // 如何去拿当前条件对应基础字段对应的值
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                let val = !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
                  ? isArray(props.formData[field.fieldCode])
                    ? props.formData[field.fieldCode].join(',')
                    : String(props.formData[field.fieldCode])
                  : ''
                // 比较值，再确定用哪一个
                const sensitiveValues = props.subFieldFormData?.sensitiveValues
                if (sensitiveValues) {
                  const hyposensitization = sensitiveValues[field.fieldCode]
                  if (hyposensitization) {
                    val =
                      hyposensitization.sensitiveValue === val
                        ? hyposensitization.originalValue
                        : val
                  }
                }
                condi.rightValue = JSON.stringify(val.split(','))
              }
            })
          })
        }
        const postData = {
          quoteTableCode: props.data.columnQuoteInfo.quoteTableCode, // 关联表单序列号
          quoteColumnList,
          conditionInfo,
          alert: props.data.columnQuoteInfo.alert || false,
          tableCode: props.data.columnQuoteInfo.tableCode
        }
        const res = await getQuoteValue(postData)
        // 还要处理echo
        dealColumnListData(res, () => {
          createTableColumns()
          setProps({
            data: res
          })
        })
      }
    }
  } else {
    ElMessage.error(`请先输入${props.data.name}`)
  }
}
const tableFieldList = ref<Recordable[]>([])
function dealColumnListData(tableData: Recordable[], fn: Fn) {
  Promise.all(
    columnsDialog.value.map((field: Recordable) => {
      return (async () => {
        let arr: any[] = []
        const { dataMark, fieldSerial, id } = field || {}
        if (dataMark === 2) {
          tableData.forEach(item => {
            !isNullOrUndefOrEmpty(item[fieldSerial]) && arr.push(item[fieldSerial])
          })
          let dataList: Recordable[] = []
          if (arr.length) {
            await getPageComponentDataEchoAcquire({
              columnId: id,
              echoData: arr.join(',')
            })
              .then(res => {
                dataList = res
              })
              .catch(() => {
                dataList = []
              })
          }
          return { ...field, ...field.columnInfo, dataList }
        } else {
          return { ...field, ...field.columnInfo }
        }
      })()
    })
  ).then(res => {
    tableFieldList.value = res
    fn && fn()
  })
}

function createTableColumns() {
  console.log(tableFieldList, 'tableFieldList777')
  const dynamicColumns = tableFieldList.value.map(field => {
    const { fieldCode, name, code, fieldSerial } = field
    let resultObj: ColumnType = {
      key: fieldCode,
      title: name,
      field: fieldCode
    }
    // 设置每列的最小宽度,不手动设置的话则以通用规则设置
    if (!resultObj.minWidth && !resultObj.width) {
      resultObj.minWidth = getTableColumnWidthByCode(code)
    }
    if (!resultObj.render && !resultObj.slot) {
      const strategyFn = dealTableValueConfig[code]
      if (strategyFn) {
        resultObj.text = row => strategyFn(field, row[fieldSerial])
      }
      resultObj.showOverflow = true
    }
    return resultObj
  })
  setProps({
    columns: [...dynamicColumns]
  })
  console.log(dynamicColumns, 'dynamicColumns666')
}
function handleReset() {
  searchTxt.value = ''
  setProps({
    data: []
  })
}

const [registerTable, { setProps, getRadioData, getTableData }] = useTable({
  data: [],
  columns: [],
  immediate: false,
  showPagination: false,
  showRowIndex: false,
  showSingleSelection: true
})
async function sure(fn?: Fn) {
  const radioData = getRadioData()
  if (!isEmpty(radioData.rowData)) {
    const { code } = props.data
    const res = getTableData()
    allListValue.value = res.list
    loading.value = false
    let dealData: Recordable[] = []
    dealData = getDealData(props.data, res.list)
    list.value = await getEchoData(props.data, dealData)
    innerValue.value = list.value[radioData.rowIndex].value
    changeValue(list.value[radioData.rowIndex].value)
    showDialog.value = false
    fn && fn()
    searchTxt.value = ''
  } else {
    ElMessage.error('请先选择数据')
  }
}

// 获取表头
function getTableTitle() {
  console.log(props.data, ' props.data')
  const columnSerials = props.data?.columnQuoteInfo?.unionDialogColumnSerials || ''
  const postData = {
    tableCode: props.data.columnQuoteInfo.quoteTableCode,
    columnSerials: columnSerials ? columnSerials.split(',') : []
  }
  return tableDialogTitleColumnList(postData).then(res => {
    const columns = res.map(item => {
      return {
        ...item,
        key: item.fieldSerial,
        title: item.name
      }
    })
    columnsDialog.value = columns
    setProps({
      columns: [...columns]
    })
  })
}

// 当前关联字段是弹窗显示还是下拉搜索显示
const isShowDialog = computed(() => {
  return props.data.columnQuoteInfo?.alert || false
})
function handleShow() {
  showDialog.value = true
  getTableTitle()
}

const list = ref<Recordable[]>([])

// 该状态决定是否根据其他引用或者映射字段改变传递进来的list
const sendVisible = ref(false)
let flag = ref(true)
onMounted(async () => {
  props.renderConfig.fieldClass.subTableEventEmitter.on(
    `refreshQuote${props.data.columnQuoteInfo?.group}`,
    (field: Recordable, fn: Fn, arr: Recordable[], res: Recordable[], index: any) => {
      // 只执行field与当前字段相同的，所以要加判断
      if (props.data.fieldSerial === field.fieldSerial && props.index === index) {
        innerValue.value = fn()
        list.value = arr || []
        sendVisible.value = true
        allListValue.value = res
        if (flag.value) {
          flag.value = false
          relevanceOtherField()
        }
        // changeValue(innerValue.value)
        // relevanceOtherField()
      }
    }
  )
  // if (props.isTxt) {
  //   getName()
  // }
  getName()

  selectOptionInit()
})

async function remoteMethod(query: string) {
  console.log(props.data, 'props.data99')
  // if (query && query !== ' ') {
  // 只有findField找得到字段，并且该字段有值才可以请求
  let conditionFlag = true
  const conditionInfo = props.data?.columnQuoteInfo?.conditionInfo
    ? JSON.parse(JSON.stringify(props.data.columnQuoteInfo.conditionInfo))
    : null
  // 这儿需要处理一下rightValue的问题，因为当前引用字段配的条件中可能有普通字段，在请求数据的时候，要把一个或多个普通字段的值带入
  // 当前条件的rightValue值中
  if (conditionInfo && conditionInfo?.conditionList) {
    // 长度最长是2，最多2个条件，conditionList
    conditionFlag = conditionInfo?.conditionList.every((condis: Recordable) => {
      // 还要判断外部条件是and，还是or ， exteriorCondition
      // 还要判断内部条件是and，还是or , interiorCondition
      let flag = false // 当前这个外部条件是否为true的标识
      // 内部条件是否为true，还要取决于内部条件的AND还是OR
      if (condis.interiorCondition && condis.interiorCondition === 'AND') {
        flag = condis.conditions.every(condi => {
          const field = findField(condi.rightColumnSerial)
          if (!isEmpty(field)) {
            return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
          } else {
            return true
          }
        })
      } else {
        flag = condis.conditions.some(condi => {
          const field = findField(condi.rightColumnSerial)
          if (!isEmpty(field)) {
            return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
          } else {
            return true
          }
        })
      }
      return flag
    })
  }
  if (conditionFlag) {
    const { code } = props.data
    let queryVal = ''
    // 这里处理值要注意
    if (props.data.dataMark === 1) {
      // 要根据query去匹配columnDataList中的label，然后找到值
      // 模糊匹配
      // const curItem = props.data.columnDataList.find(item => item.label.)
      const strategyFn = dealQuoteValueConfig[code]
      if (strategyFn) {
        queryVal = strategyFn(props.data.columnDataList, query)
      }
    } else if (props.data.dataMark === 2) {
      // 已经查询过一次了
      if (props.data.renderConfig.dataList && props.data.renderConfig.dataList.length) {
        const strategyFn = dealQuoteValueConfig[code]
        if (strategyFn) {
          queryVal = strategyFn(props.data.renderConfig.dataList, query)
        }
      } else {
        // 调用接口之后再去匹配，然后找到对应的值，传递给后端
        //
        const postData = {
          tableCode: props.data?.columnQuoteInfo?.sourceTableCode || props.data.tableCode,
          columnId: props.data.id,
          columnUseScene: props.data.columnUseScene
        }
        const res = await getPageComponentData(postData)
        emit('refreshDataList', res)
        const strategyFn = dealQuoteValueConfig[code]
        if (strategyFn) {
          queryVal = strategyFn(res, query)
        }
      }
    } else {
      queryVal = query
    }
    // if(queryVal) {
    loading.value = true
    // group相同的引用字段和映射字段的集合
    const sameGroup = getGroupField(props.data.columnQuoteInfo?.group)
    const quoteColumnList = sameGroup.map(field => {
      return {
        columnSerial: field.columnSerial,
        quoteColumnSerial: field.columnQuoteInfo.quoteColumnSerial,
        unionQueryColumnSerials: field.columnQuoteInfo.unionQueryColumnSerials || '',
        unionDialogColumnSerials: field.columnQuoteInfo.unionDialogColumnSerials || '',
        queryValue: props.data.fieldSerial === field.fieldSerial ? queryVal.split(',') : [], // 只有输入的当前字段才有值
        quoteModuleGroup: field.columnQuoteInfo.quoteModuleGroup || ''
      }
    })
    const conditionInfo = props.data?.columnQuoteInfo?.conditionInfo
      ? JSON.parse(JSON.stringify(props.data.columnQuoteInfo.conditionInfo))
      : null
    // 这儿需要处理一下rightValue的问题，因为当前引用字段配的条件中可能有普通字段，在请求数据的时候，要把一个或多个普通字段的值带入
    // 当前条件的rightValue值中
    if (conditionInfo && conditionInfo?.conditionList) {
      conditionInfo?.conditionList.forEach((condis: Recordable) => {
        condis.conditions.forEach((condi: Recordable) => {
          // 如何去拿当前条件对应基础字段对应的值
          const field = findField(condi.rightColumnSerial)
          if (!isEmpty(field)) {
            let val = !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
              ? isArray(props.formData[field.fieldCode])
                ? props.formData[field.fieldCode].join(',')
                : String(props.formData[field.fieldCode])
              : ''
            // 比较值，再确定用哪一个
            const sensitiveValues = props.subFieldFormData?.sensitiveValues
            if (sensitiveValues) {
              const hyposensitization = sensitiveValues[field.fieldCode]
              if (hyposensitization) {
                val =
                  hyposensitization.sensitiveValue === val ? hyposensitization.originalValue : val
              }
            }
            condi.rightValue = JSON.stringify(val.split(','))
          }
        })
      })
    }

    const postData = {
      quoteTableCode: props.data.columnQuoteInfo.quoteTableCode, // 关联表单序列号
      quoteColumnList,
      conditionInfo,
      alert: true,
      tableCode: props.data.columnQuoteInfo.tableCode
    }
    let res = await getQuoteValue(postData)

    dealColumnListData(res, async () => {
      const dialogColumnSerials: string[] =
        props.data.columnQuoteInfo.unionDialogColumnSerials.split(',')

      res = res.map(item => ({
        ...item,
        subShowFieldsArr:
          dialogColumnSerials
            ?.map(serial => {
              const obj: Recordable = columnsDialog.value?.find(a => serial === a.fieldSerial) || {}

              // 目前已知所有dataMark为1的都是返回的普通字符串
              if (obj?.dataMark === 1) {
                return obj.dataList
                  ?.filter(i =>
                    String(item[serial])
                      .split(',')
                      .map(i => String(i))
                      .includes(String(i.value))
                  )
                  ?.map(i => i.label)
                  ?.join('，')
              }

              // 文本展示数据拼装
              if (obj?.dataMark === 2) {
                return tableFieldList.value
                  ?.find(i => i.fieldSerial === serial)
                  ?.dataList?.filter(i => String(item[serial]).includes(String(i.value)))
                  ?.map(i => i.label)
                  ?.join('，')
              }

              // "地址"特殊处理
              if (obj.code === fieldTypeConfig.address) {
                return JSON.parse(item[serial] || '{}').full
              }

              return item[serial]
            })
            ?.filter(i => i) || []
      }))

      // 还要处理echo
      allListValue.value = res
      loading.value = false
      let dealData: Recordable[] = []
      dealData = getDealData(props.data, res)
      list.value = await getEchoData(props.data, dealData)
    })
    // }
  }
  // }
}
const currentObj = ref<Recordable>({})
function getCurrentObj(id: string) {
  const current = allListValue.value.find(item => item.id === id)
  if (current) {
    currentObj.value = current
  }
}

// 修改值
function changeValue(value: any) {
  seCustomerPage.group = []
  seCustomerPage.group.push(props.data.columnQuoteInfo.group)
  // 取出当前选择的数据所在的对象
  const current = list.value.find(item => item.value === value)
  if (current) {
    getCurrentObj(current.data_id)
    // eslint-disable-next-line vue/no-mutating-props
    emit('refreshSubListRowDataId', {
      index: props.index,
      quoteDataId: current.id
    })
  }
  nextTick(() => {
    // 回显group一组的映射字段对应的值-主表
    relateMappingField(val => () => val)
    // 回显group一组的映射字段对应的值-子表
    relateMappingTableField(val => () => val)
    relevanceOtherField()
  })
}

// 修改映射字段的值-主表
function relateMappingField(fn: Fn) {
  const relateMappingFields = getMappingFieldList(props.data.columnQuoteInfo.group).filter(item =>
    isField(item.columnQuoteInfo.quoteFieldType)
  )
  dealValAndChange(relateMappingFields, fn, false)
}
// 修改映射字段的值-子表
function relateMappingTableField(fn: Fn) {
  // 取出子表映射字段
  const relateMappingFields = getMappingFieldList(props.data.columnQuoteInfo.group).filter(item =>
    isSubList(item.columnQuoteInfo.quoteFieldType)
  )
  dealValAndChange(relateMappingFields, fn, true)
}

// 处理字段值并回显
function dealValAndChange(relateMappingFields: Recordable[], fn: Fn, isSubList: boolean) {
  if (relateMappingFields.length > 0) {
    relateMappingFields.forEach(async field => {
      let arr: Recordable[] = []
      // 不仅要刷新映射字段对应的值，而且还要传递映射字段的下拉数据，如果映射字段的下拉有多个，那映射字段对应的值取第一个
      // 拿到处理后的主表的数据和子表的数据
      const dealData: Recordable[] = isSubList
        ? getDealTableFieldData(field, allListValue.value)
        : getDealData(field, allListValue.value)
      let subListData: Recordable[] = []
      if (isSubList) {
        subListData = getTableFieldData(field, allListValue.value) || []
      }
      const obj = isSubList ? subListData[0] : currentObj.value
      arr = await getEchoData(field, dealData)
      if (obj) {
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshMapping${props.data.columnQuoteInfo?.group}`,
          field,
          fn &&
            fn(
              obj.id +
                globalEnv.specialQuoteFlag +
                (obj[field.fieldSerial] === null || !isNullOrUndefOrEmpty(obj[field.fieldSerial])
                  ? obj[field.fieldSerial]
                  : '')
            ),
          uniqueFunc(arr, 'value'),
          allListValue.value,
          props.index
        )
      } else {
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshMapping${props.data.columnQuoteInfo?.group}`,
          field,
          fn && fn(''),
          uniqueFunc(arr, 'value'),
          allListValue.value,
          props.index
        )
      }
    })
  }
}

// 抽离-处理主表数据
function getDealData(field: Recordable, list: Recordable[]) {
  let newArr: Recordable[] = []
  list.forEach(item => {
    // 取出当前主表
    const key = Object.keys(item).find(key => key === field.fieldSerial)
    const key1 = Object.keys(item).find(key => key === `D${field.fieldSerial}`)
    if (key) {
      const val = item[key]
      newArr.push({
        ...item,
        label: val,
        value: item.id + globalEnv.specialQuoteFlag + val,
        id: item.id,
        postVal: val,
        data_id: item.data_id,
        showLabel: key1 ? item[key1] : val
      })
    } else {
      // 后端没有根据要查询的映射字段key
      newArr.push({
        ...item,
        label: '-',
        value: item.id + globalEnv.specialQuoteFlag,
        id: item.id,
        postVal: '',
        data_id: item.data_id,
        showLabel: key1 ? item[key1] : ''
      })
    }
  })
  return newArr
}

// 抽离-获取子表数据
function getTableFieldData(field: Recordable, arr: Recordable[]) {
  const current = list.value.find(item => item.value === innerValue.value)
  const currentData = arr.find(item => item.id === current?.data_id)
  return currentData ? currentData[field.columnQuoteInfo.quoteModuleGroup] : []
}
// 抽离-处理子表数据
function getDealTableFieldData(field: Recordable, list: Recordable[]) {
  const arr = getTableFieldData(field, list) || []
  console.log(arr, 'arr2333')
  return getDealData(field, arr)
}

// 抽离-根据数据进行回显的处理
async function getEchoData(field: Recordable, dealData: Recordable[]) {
  let arr: Recordable[] = []
  if (field.dataMark === 2) {
    if (dealData.length) {
      const echoArr = dealData.filter(item => !isNullOrUndefOrEmpty(item.postVal))
      // 否则接口要报错
      if (echoArr.length) {
        const postData = {
          columnId: field.id,
          echoData: echoArr.map(item => item.postVal).join(',')
        }
        let echoDataRes: Recordable[] = []
        if (field.code === fieldTypeConfig.tags) {
          const echoData = echoArr.map(item => {
            return JSON.parse(
              isString(item.postVal)
                ? item.postVal
                : item.postVal.replace(/\d+/g, match => `"${match}"`)
            ).join(',')
          })
          echoDataRes = await getTagForEcho({
            ...postData,
            echoData: echoData.join(',')
          })
        } else {
          echoDataRes = await getPageComponentDataEchoAcquire({ ...postData })
        }
        arr = dealData.map(item => {
          let label = item?.label || item?.showLabel || ''
          const strategyFn = dealLabelValueConfig[field.code]
          if (strategyFn) {
            label = strategyFn(echoDataRes, String(item.postVal), field)
          }
          return {
            ...item,
            label: label || '-'
          }
        })
      } else {
        arr = dealData.map(item => {
          return {
            ...item,
            label: '-'
          }
        })
      }
    }
  } else {
    arr = dealData.map(item => {
      let label = item?.label || item?.showLabel || ''
      if (!isNullOrUndefOrEmpty(item.postVal)) {
        const strategyFn = dealLabelValueConfig[field.code]
        if (strategyFn) {
          label = strategyFn(field?.columnDataList || [], String(item.postVal), field)
        } else {
          label = item.showLabel
        }
      }
      return {
        ...item,
        label: label || item.postVal || '-'
      }
    })
  }
  return arr
}

// 修改与当前组关联的其他组的信息
function relevanceOtherField() {
  flag.value = false
  // 去查询关联得其他组，并做回显
  // relevanceQuoteList：其他组引用字段
  const { relevanceQuoteList } = relevanceFn()
  if (relevanceQuoteList.length) {
    relevanceQuoteList.forEach(async (quote: Recordable, index: any) => {
      // 只有findField找得到字段，并且该字段有值才可以请求
      let conditionFlag = true
      // 要处理对应条件中rightValue的值
      const conditionInfo = quote.columnQuoteInfo.conditionInfo
        ? JSON.parse(JSON.stringify(quote.columnQuoteInfo.conditionInfo))
        : null
      if (conditionInfo && conditionInfo?.conditionList) {
        // 长度最长是2，最多2个条件，conditionList
        conditionFlag = conditionInfo?.conditionList.every((condis: Recordable) => {
          // 还要判断外部条件是and，还是or ， exteriorCondition
          // 还要判断内部条件是and，还是or , interiorCondition
          let flag = false // 当前这个外部条件是否为true的标识
          // 内部条件是否为true，还要取决于内部条件的AND还是OR
          if (condis.interiorCondition && condis.interiorCondition === 'AND') {
            flag = condis.conditions.every(condi => {
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
              } else {
                return true
              }
            })
          } else {
            flag = condis.conditions.some(condi => {
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
              } else {
                return true
              }
            })
          }
          return flag
        })
      }
      if (conditionFlag) {
        // group相同的引用字段和映射字段的集合
        const sameGroup = getGroupField(quote.columnQuoteInfo.group)
        // 拿到当前引用字段，去调接口，拿到该组的所有数据，分别去触发引用字段和映射字段的回显
        const quoteColumnList = sameGroup.map(field => {
          return {
            columnSerial: field.columnSerial,
            quoteColumnSerial: field.columnQuoteInfo.quoteColumnSerial,
            unionQueryColumnSerials: field.columnQuoteInfo.unionQueryColumnSerials || '',
            queryValue: currentObj.value[field.fieldSerial]
              ? currentObj.value[field.fieldSerial].split(',')
              : [],
            quoteModuleGroup: field.columnQuoteInfo.quoteModuleGroup || ''
          }
        })
        // 要处理对应条件中rightValue的值
        const conditionInfo = quote.columnQuoteInfo.conditionInfo
          ? JSON.parse(JSON.stringify(quote.columnQuoteInfo.conditionInfo))
          : null
        if (conditionInfo && conditionInfo?.conditionList) {
          conditionInfo?.conditionList.forEach((condis: Recordable) => {
            condis.conditions.forEach((condi: Recordable) => {
              // 如何去拿当前条件对应基础字段对应的值
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                let val = !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
                  ? isArray(props.formData[field.fieldCode])
                    ? props.formData[field.fieldCode].join(',')
                    : String(props.formData[field.fieldCode])
                  : ''
                // 比较值，再确定用哪一个
                const sensitiveValues = props.subFieldFormData?.sensitiveValues
                if (sensitiveValues) {
                  const hyposensitization = sensitiveValues[field.fieldCode]
                  if (hyposensitization) {
                    val =
                      hyposensitization.sensitiveValue === val
                        ? hyposensitization.originalValue
                        : val
                  }
                }
                condi.rightValue = JSON.stringify(val.split(','))
              } else {
                condi.rightValue = currentObj.value[condi.rightColumnSerial]
                  ? isString(currentObj.value[condi.rightColumnSerial])
                    ? JSON.stringify(currentObj.value[condi.rightColumnSerial].split(','))
                    : currentObj.value[condi.rightColumnSerial]
                  : JSON.stringify([])
              }
            })
          })
        }
        const postData = {
          quoteTableCode: quote.columnQuoteInfo.quoteTableCode, // 关联表单序列号
          quoteColumnList,
          conditionInfo,
          alert: props.data.columnQuoteInfo.alert || false,
          tableCode: quote.columnQuoteInfo.tableCode
        }
        // 排除自己
        if (seCustomerPage.group.indexOf(quote.columnQuoteInfo.group) === -1) {
          // 获取到该组的数据
          const res = await getQuoteValue(postData)
          seCustomerPage.group.push(quote.columnQuoteInfo.group)

          // 获取到当前引用字段对应的所有映射字段-也要区分主表字段和子表字段
          await relateMappingFieldOther(quote, res) // -主表
          await relateMappingTableFieldOther(quote, res) // -子表

          // 处理引用字段的值-也要区分该引用字段是主表字段还是子表字段
          let arr: Recordable[] = []
          const dealData = getDealData(quote, res)
          arr = await getEchoData(quote, dealData)
          const fn = (val: any) => () => val
          props.renderConfig.fieldClass.subTableEventEmitter.emit(
            `refreshQuote${quote.columnQuoteInfo?.group}`,
            quote,
            fn && fn(arr?.[0]?.value),
            arr,
            res,
            isSubList(quote.fieldType) ? 0 : arr?.[0]?.id // 当前引用字段可能也是子表中的字段，也可能是分栏中的字段
          )
        }
      }
    })
  }
}

// 处理其他组映射字段的值-主表
async function relateMappingFieldOther(quote: Recordable, res: Recordable[]) {
  // 取出主表映射字段
  const relateMappingFields = getMappingFieldList(quote.columnQuoteInfo.group).filter(item =>
    isField(item.columnQuoteInfo.quoteFieldType)
  )
  // 处理映射字段的值
  await dealValAndChangeOther(relateMappingFields, res, false)
}
// 处理其他组映射字段的值-子表
async function relateMappingTableFieldOther(quote: Recordable, res: Recordable[]) {
  // 取出主表映射字段
  const relateMappingFields = getMappingFieldList(quote.columnQuoteInfo.group).filter(item =>
    isSubList(item.columnQuoteInfo.quoteFieldType)
  )
  // 处理映射字段的值
  await dealValAndChangeOther(relateMappingFields, res, true)
}

// 处理字段值并回显-other
async function dealValAndChangeOther(
  relateMappingFields: Recordable[],
  res: Recordable[],
  isSubListBool: boolean
) {
  if (relateMappingFields.length > 0) {
    for (const field of relateMappingFields) {
      // 不仅要刷新映射字段对应的值，而且还要传递映射字段的下拉数据，如果映射字段的下拉有多个，那映射字段对应的值取第一个
      let arr: Recordable[] = []
      // 不仅要刷新映射字段对应的值，而且还要传递映射字段的下拉数据，如果映射字段的下拉有多个，那映射字段对应的值取第一个
      // 拿到处理后的主表的数据和子表的数据
      const dealData: Recordable[] = isSubListBool
        ? getDealTableFieldData(field, res)
        : getDealData(field, res)
      let subListData: Recordable[] = []
      if (isSubListBool) {
        subListData = getTableFieldData(field, allListValue.value) || []
      }
      const obj = isSubListBool ? subListData[0] : currentObj.value
      arr = await getEchoData(field, dealData)
      const fn = (val: any) => () => val
      // 触发刷新当前引用字段对应的映射字段的值
      props.renderConfig.fieldClass.subTableEventEmitter.emit(
        `refreshMapping${field.columnQuoteInfo.group}`,
        field,
        fn && fn(arr?.[0]?.value),
        arr,
        res,
        isSubList(field.fieldType) ? 0 : arr?.[0]?.id // 当前引用字段可能也是子表中的字段，也可能是分栏中的字段
      )
    }
  }
}

// 取出与当前引用字段的group相同的映射字段
function getMappingFieldList(group: string) {
  // 要给group相同的所有的映射字段赋值
  const mappingFieldList = props.quoteMappingConfig.mappingFieldList
  const relateMappingFields: Recordable[] = []
  // 取出与当前引用字段的group相同的映射字段
  mappingFieldList.forEach(i => {
    if (i.columnQuoteInfo.group === group) {
      relateMappingFields.push({ ...i })
    }
  })
  return relateMappingFields
}

// 根据当前引用或者映射字段，找到group相同的一组字段
function getGroupField(group: string) {
  const sameGroup: Recordable[] = []
  props.positions.forEach(container => {
    if (container.code === 'TABLE') {
      container.children.forEach((child: Recordable) => {
        child.modules.forEach((module: Recordable) => {
          module.componentList.forEach((field: Recordable) => {
            if (field?.columnQuoteInfo?.group === group) {
              sameGroup.push({ ...field })
            }
          })
        })
      })
    }
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.componentList.forEach((field: Recordable) => {
          if (field?.columnQuoteInfo?.group === group) {
            sameGroup.push({ ...field })
          }
        })
      })
    }
  })
  return sameGroup
}

// 通过当前组去匹配其他组是否有关联
function relevanceFn() {
  // 有关联的其他组的引用字段数据组
  const relevanceQuoteList: Recordable[] = []
  // 匹配成功的fieldSerial
  const relevanceFieldSerials: string[] = []
  // 当前组的映射字段
  const relateMappingFields = getMappingFieldList(props.data.columnQuoteInfo.group)
  // 排除当前引用字段之后剩余的其他引用字段
  const quoteFieldList = props.quoteMappingConfig.quoteFieldList.filter(
    (item: Recordable) => item.fieldSerial !== props.data.fieldSerial
  )
  quoteFieldList.forEach(item => {
    // 这是其他引用字段循环中，判断该引用字段有没有条件，以下是由条件的判断
    const columnQuoteInfo = item.columnQuoteInfo
    // 正查，根据当前编辑的引用字段去查找其他引用字段条件中配置的条件是否与当前编辑的引用字段相同的group组字段相关
    if (
      columnQuoteInfo &&
      columnQuoteInfo.conditionInfo &&
      columnQuoteInfo.conditionInfo.conditionList &&
      columnQuoteInfo.conditionInfo.conditionList.length
    ) {
      columnQuoteInfo.conditionInfo?.conditionList.forEach(condition => {
        condition.conditions.forEach(condi => {
          // 当前引用字段是否和条件匹配
          if (props.data.fieldSerial === condi.rightColumnSerial) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(condi.rightColumnSerial)
            }
            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
          // 当前其他映射字段是否和条件匹配
          const current = relateMappingFields.find(
            mapping => mapping.fieldSerial === condi.rightColumnSerial
          )
          if (current) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(condi.rightColumnSerial)
            }
            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
        })
      })
    }
    // 反查，根据当前编辑的引用字段的条件去查抄其他group组字段相关
    const currentColumnQuoteInfo = props.data.columnQuoteInfo
    if (
      currentColumnQuoteInfo &&
      currentColumnQuoteInfo.conditionInfo &&
      currentColumnQuoteInfo.conditionInfo.conditionList &&
      currentColumnQuoteInfo.conditionInfo.conditionList.length
    ) {
      // 这是当前编辑的引用字段的条件
      currentColumnQuoteInfo.conditionInfo.conditionList.forEach(condition => {
        condition.conditions.forEach(condi => {
          // 根据当前条件去匹配其他group的字段的fieldSerial
          // 这是其他group对应的映射字段list
          const otherMappingList = getMappingFieldList(item.columnQuoteInfo.group)
          const current = otherMappingList.find(
            mapping => mapping.fieldSerial === condi.rightColumnSerial
          )
          if (current) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(current.fieldSerial)
            }

            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
          // 其他group的引用字段. item就是其他引用字段
          if (condi.rightColumnSerial === item.fieldSerial) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(item.fieldSerial)
            }
            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
        })
      })
    }
  })
  return { relevanceQuoteList, relevanceFieldSerials }
}

// 根据传入的serial去找到对应的字段，该字段必须是普通字段
function findField(columnSerial: string): Recordable {
  let obj: Recordable = {}
  props.positions.forEach(container => {
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.componentList.forEach((field: Recordable) => {
          if (
            field.fieldSerial === columnSerial &&
            field.fieldType !== fieldTypeEnum.SYS_QUOTE &&
            field.fieldType !== fieldTypeEnum.CUSTOM_QUOTE &&
            field.fieldType !== fieldTypeEnum.SYS_MAPPING &&
            field.fieldType !== fieldTypeEnum.CUSTOM_MAPPING &&
            field.fieldType !== fieldTypeEnum.SON_SYS_QUOTE &&
            field.fieldType !== fieldTypeEnum.SON_CUSTOM_QUOTE &&
            field.fieldType !== fieldTypeEnum.SON_SYS_MAPPING &&
            field.fieldType !== fieldTypeEnum.SON_CUSTOM_MAPPING
          ) {
            obj = field
            return
          }
        })
      })
    }
    if (container.code === 'TABLE') {
      container.children.forEach(child => {
        child.modules.forEach(module => {
          module.componentList.forEach((field: Recordable) => {
            if (
              field.fieldSerial === columnSerial &&
              field.fieldType !== fieldTypeEnum.SYS_QUOTE &&
              field.fieldType !== fieldTypeEnum.CUSTOM_QUOTE &&
              field.fieldType !== fieldTypeEnum.SYS_MAPPING &&
              field.fieldType !== fieldTypeEnum.CUSTOM_MAPPING &&
              field.fieldType !== fieldTypeEnum.SON_SYS_QUOTE &&
              field.fieldType !== fieldTypeEnum.SON_CUSTOM_QUOTE &&
              field.fieldType !== fieldTypeEnum.SON_SYS_MAPPING &&
              field.fieldType !== fieldTypeEnum.SON_CUSTOM_MAPPING
            ) {
              obj = field
              return
            }
          })
        })
      })
    }
  })
  return obj
}

async function getName() {
  const { code, dataMark, id } = props.data
  if (innerValue.value) {
    if (dataMark === 2) {
      const postData = {
        columnId: id,
        echoData: isArray(innerValue.value) ? innerValue.value.join(',') : innerValue.value
      }
      let echoDataRes: Recordable[] = []
      if (code === fieldTypeConfig.tags) {
        const echoData = isString(innerValue.value)
          ? innerValue.value
          : innerValue.value.replace(/\d+/g, match => `"${match}"`)
        echoDataRes = await getTagForEcho({
          ...postData,
          echoData: JSON.parse(echoData).join(',')
        })
      } else {
        echoDataRes = await getPageComponentDataEchoAcquire({ ...postData })
      }
      let label = ''
      const strategyFn = dealLabelValueConfig[code]
      if (strategyFn) {
        label = strategyFn(echoDataRes, String(innerValue.value), props.data)
      }
      name.value = label || '-'
      list.value = [{ label: name.value, value: innerValue.value }]
    } else {
      let label = ''
      const strategyFn = dealLabelValueConfig[code]
      if (strategyFn) {
        label = strategyFn(props.data?.columnDataList || [], String(innerValue.value), props.data)
      } else {
        const value = props.data.renderConfig.valCallback(innerValue.value, props.data)
        label = !isNullOrUndefOrEmpty(value) ? value : '-'
      }
      name.value = label
      list.value = [{ label: name.value, value: innerValue.value }]
    }
  } else {
    name.value = '-'
    // list.value = [{ label: name.value, value: innerValue.value }]
  }
}

async function selectOptionInit() {
  await getTableTitle()
  remoteMethod('')
}

watch(
  () => props.isTxt,
  val => {
    if (val) {
      getName()
    } else {
      selectOptionInit()
    }
  }
)
</script>
<style lang="scss" scoped>
.quote-box {
  position: relative;
  width: 100%;
  .showDialogOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  }
}
.dialog-box {
  .title-search {
    display: flex;
    align-items: center;
    padding: 24px 16px;
    .title {
      margin-right: 8px;
    }
  }
  .table-box {
    padding: 0 16px;
  }
}
.custom-select {
  :deep(.is-reverse) {
    transform: none !important;
  }
}
</style>

<style lang="scss">
.quote-tableSubList-el-select-popover {
  .el-select-dropdown__item {
    width: 100%;
    height: fit-content;
    max-height: 52px;
    padding: 5px 20px;

    .content {
      div {
        height: 22px;
        line-height: 22px;
      }
      .tags {
        height: 20px;
        line-height: 20px;
        display: flex;
        align-items: center;
        .item {
          max-width: 50%;
          font-size: 12px;
          color: #999999;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          white-space: nowrap;
        }
        .line {
          color: #ebeef5;
          margin: 0 6px;
        }
      }
    }
  }
}
</style>
